<template>
  <div class="row-fluid documents-wrapper">
    <spinner :visible="this.loading" :overlay="true"></spinner>
    <div id="documents-filters">
      <div class="filters-container">
        <div class="viewer">
          <div class="view-switcher">
            <i class="fa-light fa-grid-2" :class="{ selected: this.view == 'cards' }" @click="setView('cards')" />
            <i class="fa-light fa-bars" :class="{ selected: this.view == 'table' }" @click="setView('table')" />
          </div>
        </div>
        <div class="filters">
          <div class="view-switcher">
            {{ this.filters.date_direction }}
            <i
              class="fa-light fa-calendar-arrow-down"
              :class="{ selected: this.orders.date == 'desc' }"
              @click="setOrdersDateDirection('desc')"
            />
            <i
              class="fa-light fa-calendar-arrow-up"
              :class="{ selected: this.orders.date == 'asc' }"
              @click="setOrdersDateDirection('asc')"
            />
          </div>
          <div class="tags-container">
            <div :class="`tags-action ${tagsActive ? 'tags-action--active' : ''}`" @click="openTagsList">TAGS</div>
            <div class="tags-list">
              <switchComponent :value="filters.tbs" @input="toggleFlag('tbs')" :label="i18nJS.doc_index_flags.tbs" />
              <tags :business_unit_id="business_unit_id" :resource="'document'" :node_count="node_count" :gpds_id="filters.gpdsid" />
            </div>
          </div>
          <div class="switcher">
            <switchComponent
              :value="filters.san"
              @input="toggleFlag('san')"
              :icon_hint="i18nJS.sanitaries"
              :icon="'fa-light fa-notes-medical'"
            />
            <switchComponent
              :value="filters.res"
              @input="toggleFlag('res')"
              :icon_hint="i18nJS.riservati"
              :icon="'fa-light fa-user-secret'"
            />
            <switchComponent
              :value="filters.sig"
              @input="toggleFlag('sig')"
              :icon_hint="i18nJS.filter_sign.signed"
              :icon="'fa-light fa-file-signature'"
            />
            <switchComponent
              v-if="type == 'guest'"
              :value="filters.pwf"
              @input="toggleFlag('pwf')"
              :icon_hint="i18nJS.print_with_folder"
              :icon="'fa-light fa-paperclip'"
            />
            <switchComponent
              v-if="type == 'guest' && fse"
              :value="filters.fse"
              @input="toggleFlag('fse')"
              :icon_hint="'Documento FSE'"
              :label="'FSE'"
            />
          </div>
          <span class="title-filter-wrapper">
            <input
              type="text"
              class="title-filter"
              :placeholder="i18nJS.title_or_filename_search"
              v-model="filters.title"
              @blur="confirmTitleFilter"
              @keyup.enter="confirmTitleFilter"
              @keyup.esc="undoTitleFilter"
            />
            <!--<i class="fa-light fa-circle-xmark clear-title-filter" @click="clearTitleFilter" />-->
          </span>
          <span class="creator-filter-wrapper">
            <v-select2
              v-model="filters.created_who"
              :data-ajax--url="usersPath"
              :data-minimumInputLength="1"
              :data-placeholder="i18nJS.creator"
              @input="confirmUserFilter"
              data-pageLimit="20"
              :data-allow-clear="true"
              id="select2-creator"
              :class="'full-width user-filter'"
            >
            </v-select2>
          </span>
          <span class="user-filter-wrapper" v-if="this.type == 'users_business_unit'">
            <v-select2
              v-model="filters.user_id"
              :data-ajax--url="ubuPath"
              :data-minimumInputLength="1"
              :data-placeholder="i18nJS.user_label"
              @input="confirmUserFilter"
              data-pageLimit="20"
              :data-allow-clear="true"
              id="select2-user"
              :class="'full-width user-filter'"
            >
            </v-select2>
          </span>
          <span class="guest-filter-wrapper" v-if="this.type == 'guest' && !this.gpds_id">
            <v-select2
              v-model="filters.gpdsid"
              :data-ajax--url="gpdssPath"
              :data-minimumInputLength="1"
              :data-placeholder="i18nJS.guest_label"
              @input="confirmGuestFilter"
              data-pageLimit="20"
              :data-allow-clear="true"
              id="select2-guest"
              :selectConfig="gpdsSelectConfig"
              :class="'full-width guest-filter'"
            >
            </v-select2>
          </span>
        </div>
      </div>
    </div>
    <div class="documents-container">
      <div class="no-res alert alert-warning center" v-if="timeout">{{ i18nJS.errors.timeout }}</div>
      <div class="no-res alert alert-warning center" v-if="access_denied">{{ i18nJS.access_denied }}</div>
      <div class="no-res alert alert-error center" v-if="error">{{ i18nJS.errors.critical_error }}</div>
      <div class="no-res alert alert-info center" v-if="noError && documents.length == 0">{{ i18nJS.nessun_risultato_trovato }}</div>
      <documentz
        v-for="(document, index) in documents"
        v-bind:key="document.id"
        :id="document.id"
        :infos="document.infos"
        :business_unit_id="business_unit_id"
        :title="document.title"
        :filename="document.filename"
        :content_type="document.content_type"
        :size="document.size"
        :tags="document.tags"
        :url="document.url"
        :reserved="document.riservato"
        :san="document.san"
        :pwf="document.pwf"
        :shared_jobs="document.shared_jobs"
        :shared_ubu_ids="document.shared_ubu_ids"
        :tag_options="tag_options"
        :editor="document.editor"
        :editor_job="document.editor_job"
        :avatar="document.avatar"
        :signed="document.signed"
        :sign_enabled="sign_enabled"
        :updated_at="document.updated_at"
        :view.sync="view"
        :relative_to="document.relative_to"
        :odd="index % 2"
        :permissions="document.permissions"
        :gpds_id="document.gpds_id"
        :current_gpds_id="gpds_id"
        :kind="document.kind"
        :personal="document.personal"
        :created_who="document.created_who"
        :stored_status="document.stored_status"
        :job_options="job_options"
        :view_type="type"
        :last_period="document.last_period"
        :show_preview="show_preview"
        :only_preview="only_preview"
        :folder_closed="folder_closed"
        :enable_only_reports="enable_only_reports"
      />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { Route } from '../../route';
import spinner from '../spinner';
import switchComponent from '../switchComponent';
import documentz from './documentz';
import vSelect2 from '../vSelect2';
import tags from '../tags/tags';
import { behavior } from '@/behaviors/components/file_preview';

export default {
  name: 'documents',
  data() {
    return {
      documents: [],
      loading: true,
      filters: {
        san: false,
        res: false,
        sig: false,
        att: false,
        pwf: false,
        tbs: true,
        fse: false,
        title: null,
        created_who: null,
        gpdsid: null,
        user_id: null,
      },
      orders: {
        date: 'asc',
      },
      error: false,
      timeout: false,
      access_denied: false,
      selected_tag_id: -1,
      stopPaging: false,
      page: 1,
      view: 'table',
      tagsActive: false,
    };
  },
  props: {
    business_unit_id: { type: Number, required: true },
    gpds_id: { type: Number },
    node_count: { type: Object, default: null },
    sign_enabled: { type: Boolean, default: false },
    tag_options: { type: Array, default: () => [] },
    type: { type: String },
    page_size: { type: Number, default: 10 },
    controller_name: { type: String, default: 'BusinessUnit' },
    controller_id: { type: Number, required: true },
    job_options: { type: Array, default: () => [] },
    fse: { type: Boolean, default: false },
    show_preview: { type: Boolean },
    only_preview: { type: Boolean },
    enable_only_reports: { type: Boolean },
    folder_closed: { type: Boolean },
  },
  components: {
    documentz,
    spinner,
    switchComponent,
    tags,
    vSelect2,
  },
  computed: {
    noError() {
      return !this.error && !this.timeout && !this.access_denied;
    },
    i18nJS() {
      return window.i18nJS;
    },
    gpdssPath() {
      return `/${window.locale}/guest_period_data_sets/autocomplete_guest_firstname.json`;
    },
    usersPath() {
      return `/${window.locale}/users.json?business_unit_id=${this.business_unit_id}&online=false&type[]=presents&type[]=out&type[]=absents`;
    },
    ubuPath() {
      return `/${window.locale}/users_business_units/autocomplete_user_firstname.json?business_unit_id=${this.business_unit_id}`;
    },
    gpdsSelectConfig() {
      return {
        placeholder: `${window.i18nJS.activity.selectEl}`,
        url: this.gpdssPath,
        processResults: (data) => ({
          results: data.map((data) => {
            return { id: data.id.replaceAll(/[^\d]*/g, ''), text: data.label };
          }),
        }),
      };
    },
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  mounted() {
    this.filters.gpdsid = this.gpds_id;
    eventBus.$on('clickOnTag', this.handleReloadDocuments);
    eventBus.$on('updatingDoc', this.handleDocUpdating);
    eventBus.$on('updatedDoc', this.handleDocUpdated);
    eventBus.$on('removedDoc', this.handleDocRemoval);
    behavior('.documents-container');

    this.loadDocs(0).then((res) => {
      this.loading = false;
    });
  },
  methods: {
    handleScroll() {
      let scrollHeight = window.scrollY;
      let maxHeight = window.document.body.scrollHeight - window.document.documentElement.clientHeight;
      if (!this.loading && !this.stopPaging && scrollHeight >= maxHeight - 200) {
        this.page = this.page + 1;
        this.loadDocs(this.selected_tag_id, false);
      }
    },
    setView(view) {
      this.view = view;
    },
    setOrdersDateDirection(direction) {
      this.orders.date = direction;
      this.loading = true;
      this.documents = [];
      this.page = 1;
      this.loadDocs(this.selected_tag_id);
    },
    clearTitleFilter() {
      if (this.filters.title && this.filters.title.length) {
        this.filters.title = null;
        this.page = 1;
        this.loadDocs(this.selected_tag_id);
      }
    },
    toggleFlag(flag) {
      this.filters[flag] = !this.filters[flag];
      this.page = 1;
      this.loadDocs(this.selected_tag_id).catch((res) => {
        this.filters[flag] = !this.filters[flag];
      });
    },
    handleDocUpdating(event) {
      this.loading = true;
    },
    handleDocUpdated(event) {
      this.loading = false;
    },
    handleDocRemoval(event) {
      this.loading = false;
      let oldDocs = [];
      this.documents.forEach((ele) => oldDocs.push(ele));
      this.documents.splice(0, this.documents.length);
      oldDocs.forEach((ele) => {
        if (ele.id != event.id) {
          this.documents.push(ele);
        }
      });
    },
    handleReloadDocuments(event) {
      this.selected_tag_id = event.id;
      if (this.selected_tag_id) {
        this.loading = true;
        this.documents = [];
        this.page = 1;
        this.loadDocs(this.selected_tag_id);
      }
    },
    loadDocs(tag_id, clear = true) {
      this.error = false;
      this.timeout = false;
      this.access_denied = false;
      let url = `${Route.DOCUMENTS_BY_TAG.replace('__TAG_ID__', tag_id)}`;
      if (this.type) {
        url = `${url}?type=${this.type}&`;
      }
      if (this.controller_name && this.controller_id && this.controller_name.length) {
        url = `${url}?controller_name=${this.controller_name}&`;
        if (this.controller_id > 0 && !this.filters.gpdsid) {
          url = `${url}controller_id=${this.controller_id}&`;
        }
      } else {
        url = `${url}?`;
      }
      if (this.filters.tbs) {
        url = `${url}tbs&`;
      }
      if (this.filters.gpdsid) {
        url = `${url}guest_period_data_set_id=${this.filters.gpdsid}&`;
      }
      if (this.orders.date) {
        url = `${url}orders_date=${this.orders.date}&`;
      }
      let flag_params = [];
      for (let flag in this.filters) {
        if (flag != 'title' && this.filters[flag]) {
          flag_params.push(flag);
        }
      }
      url = url + flag_params.join('&');
      if (this.filters.title) {
        url = url + '&term=' + this.filters.title;
      }
      if (this.filters.created_who) {
        url = url + '&created_who=' + this.filters.created_who;
      }
      if (this.filters.user_id) {
        url = url + '&user_ids[]=' + this.filters.user_id;
      }

      url = url + `&page=${this.page}`;
      return new Promise((resolve, reject) => {
        this.loading = true;
        this.stopPaging = false;
        axios
          .get(url)
          .then(({ data }) => {
            const documents = data.documents;
            if (data.tag_count) {
              eventBus.$emit('tags_count_recalc', data.tag_count);
            }
            this.loading = false;
            if (documents.length < this.page_size) {
              this.stopPaging = true;
            }
            if (clear) {
              this.documents.splice(0, this.documents.length);
            }
            documents.forEach((ele) => this.documents.push(ele));
            resolve();
          })
          .catch((error) => {
            this.loading = false;
            if (error.response && (error.response.status == 504 || error.response.status == 408)) {
              this.timeout = true;
            } else if (error.response && (error.response.status == 401 || error.response.status == 403)) {
              this.access_denied = true;
            } else {
              this.error = true;
            }
            reject();
          });
      });
    },
    confirmGuestFilter() {
      this.page = 1;
      this.loadDocs(this.selected_tag_id).catch((res) => {
        this.filters.gpdsid = null;
      });
    },
    confirmUserFilter() {
      this.page = 1;
      this.loadDocs(this.selected_tag_id).catch((res) => {
        this.filters.user_id = null;
      });
    },
    confirmTitleFilter() {
      this.page = 1;
      this.loadDocs(this.selected_tag_id).catch((res) => {
        this.filters.title = null;
      });
    },
    openTagsList() {
      this.tagsActive = !this.tagsActive;
    },
  },
};
</script>

<style lang="scss">
.documents-wrapper {
  .documents-container > .topcontainer:even {
    background-color: #f9f9f9;
  }

  .tree-arrow {
    margin-left: 0;
  }

  .tree-root {
    margin: 0;
    font-size: 1.4rem;

    .count {
      font-size: 1.2rem;
    }
  }

  .cmp-switch-cont {
    label {
      margin: 0;
      font-size: 1.4rem;
    }
  }
}
</style>

<style lang="scss" scoped>
.tags-container {
  position: relative;

  .tags-action {
    border-radius: 10px 10px;
    color: white;
    padding: 4px 10px;
    border-radius: 10px 10px;
    margin-top: 3px;
    cursor: pointer;

    &--active {
      background-color: var(--adv-secondary-color);
      border-color: var(--adv-secondary-color);

      + .tags-list {
        display: block;
      }
    }
  }

  .tags-list {
    width: 600px;
    position: absolute;
    left: 0;
    top: 40px;
    z-index: 2;
    background-color: #f9f9f9;
    box-shadow: 0.5px 0.5px 3px 0.5px var(--adv-inactive-color);
    padding: 4px;
    border-radius: 6px;
    display: none;
    max-height: 500px;
    overflow: auto;
  }
}

.viewer {
  display: flex;
  width: 100px;
  display: none;

  @media screen and (min-width: 1024px) {
    display: flex;
  }
}

.switcher {
  // max-width: 200px;
  display: none;
  overflow-x: auto;
  @media screen and (min-width: 1024px) {
    display: flex;
  }
}

.filters {
  display: flex;
  justify-content: flex-end;
  margin-top: 4px;

  > * {
    margin: 0 10px;
  }
}

.filters-container {
  position: relative;
  height: 100%;
  justify-content: flex-end;
  display: flex;
  align-items: center;
  font-size: 1.4rem;

  @media screen and (min-width: 1024px) {
    justify-content: space-between;
  }

  i {
    font-size: 18px;
  }
}

#documents-filters {
  width: 100%;
  background-color: var(--adv-primary-color);
  border-radius: 6px;
  box-shadow: 0.5px 0.5px 3px 0.5px var(--adv-inactive-color);
  color: white;
  height: 50px;
}

.documents-container {
  flex-wrap: wrap;
  width: 100%;
  margin-top: 1em;
  display: flex;
}

.content {
  display: flex;
  flex-flow: column;
  width: 100%;
}
.no-res {
  margin: 2em;
  width: 90%;
}
.guest-filter-wrapper,
.user-filter-wrapper,
.creator-filter-wrapper {
  position: relative;
  width: 12em;
  display: none;

  @media screen and (min-width: 1024px) {
    display: block;
  }
}
.title-filter-wrapper {
  position: relative;

  & > .title-filter {
    width: 215px;
  }
  & > .clear-title-filter {
    position: relative;
    left: -1.8em;
    color: #6c6c6c;
    cursor: pointer;
  }
}
.guest-filter,
.user-filter {
  padding-right: 2em;
}
.view-switcher {
  display: flex;
  margin: 0 10px;

  & > i {
    cursor: pointer;
    font-size: 16px;
    height: 30px;
    width: 30px;
    position: relative;
    border-radius: 50%;

    &::before {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate3d(-50%, -50%, 0);
    }
  }
  & > .selected {
    color: white;
    background-color: #f39033;
    border-radius: 100%;
  }
}
</style>
